import { ApiMode, Widgets } from '@alma/widgets'
import './AlmaWidget.css'
import React, { useId, useState } from 'react'
import { useEffect } from 'react'
interface AlmaWidgetProps {
  merchantId: string
  cents: number
}

// TODO: use "useId" after React 18 upgrade
export default function AlmaWidget({ merchantId, cents }: AlmaWidgetProps) {
  const [error, setError] = useState(null)
  const widgetId = useId()

  useEffect(() => {
    const mode = process.env.NODE_ENV === 'production' ? 'LIVE' : 'TEST'

    try {
      const widgets = Widgets.initialize(merchantId, ApiMode[mode])

      widgets.add(Widgets.PaymentPlans, {
        container: `#${widgetId}`,
        purchaseAmount: cents,
        hideBorder: true,
        monochrome: true,
        locale: 'fr',
      })
    } catch (error) {
      setError(error.message)
    }
  }, [merchantId, cents])

  if (error) {
    return (
      <div className='c-message c-message--error'>
        Impossible de charger les informations pour le paiement en plusieurs
        fois (Alma).
      </div>
    )
  }

  return <span style={{ zoom: 0.9, maxWidth: 'max-content' }} id={widgetId} />
}
